export const domainsImplementingErrorCodes = ["https://ai.jaas.eu", "http://localhost:8080"];
